import { Type } from '@angular/core'

import { Section } from 'app/core/cms/type-unions'

import { CmsBlock } from '../cms-block'
import { SectionBasicComponent } from './section-basic/section-basic.component'
import { SectionBoxedTextComponent } from './section-boxed-text/section-boxed-text.component'
import { SectionContactComponent } from './section-contact/section-contact.component'
import { SectionContentMediaComponent } from './section-content-media/section-content-media.component'
import { SectionContentSplitComponent } from './section-content-split/section-content-split.component'
import { SectionFilterItemsComponent } from './section-filter-items/section-filter-items.component'

type SectionMapping = {
  [key in Section['__typename']]: Type<CmsBlock<Section & { __typename: key }>>
}

export const SECTION_MAPPING = {
  SectionBoxedText: SectionBoxedTextComponent,
  SectionBasic: SectionBasicComponent,
  SectionContentMedia: SectionContentMediaComponent,
  SectionContact: SectionContactComponent,
  SectionContentSplit: SectionContentSplitComponent,
  SectionFilterItems: SectionFilterItemsComponent,
} as const satisfies SectionMapping
